<script lang="ts">
  import {Button} from 'flowbite-svelte';
  import {cn} from 'Catalyst/cn';
  import {Icon, type IconTVProps} from 'Catalyst/components/Icon';
  import {
    iconButtonVariantsSizeLgIconsDensity,
    iconButtonVariantsSizeLgIconsSize,
    iconButtonVariantsSizeMdIconsDensity,
    iconButtonVariantsSizeMdIconsSize,
    iconButtonVariantsSizeSmIconsDensity,
    iconButtonVariantsSizeSmIconsSize,
    iconButtonVariantsSizeXlIconsDensity,
    iconButtonVariantsSizeXlIconsSize,
  } from 'Catalyst/tokens/output/icon-button';
  import type {IconButtonProps} from '.';
  import {iconButtonTvProps} from '.';

  // eslint-disable-next-line no-unused-vars
  type $$Props = IconButtonProps;

  const iconPropsMap = {
    xl: {
      density: iconButtonVariantsSizeXlIconsDensity,
      size: iconButtonVariantsSizeXlIconsSize,
    },
    lg: {
      density: iconButtonVariantsSizeLgIconsDensity,
      size: iconButtonVariantsSizeLgIconsSize,
    },
    md: {
      density: iconButtonVariantsSizeMdIconsDensity,
      size: iconButtonVariantsSizeMdIconsSize,
    },
    sm: {
      density: iconButtonVariantsSizeSmIconsDensity,
      size: iconButtonVariantsSizeSmIconsSize,
    },
  };

  export let icon: IconButtonProps['icon'] = 'local_fire_department';
  export let iconFilled: IconButtonProps['iconFilled'] = false;
  export let size: IconButtonProps['size'] =
    iconButtonTvProps.defaultVariants.size;
  export let style: IconButtonProps['style'] =
    iconButtonTvProps.defaultVariants.style;

  const iconButtonTvSlots = iconButtonTvProps({size, style});

  const iconProps = iconPropsMap[size] as IconTVProps;

  const klass = $$restProps.class;
</script>

<Button
  {...$$restProps}
  class={cn(iconButtonTvSlots.base(), klass)}
  on:change
  on:click
  on:keydown
  on:keyup
  on:focus
  on:mouseenter
  on:mouseleave
  on:touchcancel
  on:touchend
  on:touchstart
>
  <Icon {...iconProps} name={icon} filled={iconFilled} />
</Button>
